import React, { useState } from "react";
import CustomInput from "../../Input";
import { Divider, Grid } from "@material-ui/core";
import CustomImagePicker from "../../ImagePicker";
import ModalContainer from "../../Modals/AddContainer";
import FormValidator from "../../../../services/FormValidator";
import SaveIcon from "../../../../assets/icons/save_icon.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/icons/cross_circle.svg";
import "./FeedbackForm.scss";

//Form to be filled by the user for feedback.
const FeedbackForm = ({
  onClose,
  submitHandler,
  allowEmailInput,
  triggerErrorToast,
}) => {
  const [state, setState] = useState({
    screenshot: "",
    message: "",
    email: "",
  });

  //Rules for form.
  const rules = allowEmailInput
    ? { message: { required: true }, email: { required: true } }
    : { message: { required: true } };

  const messageFeedbackRows = allowEmailInput ? 4 : 8;

  //Function to handle screenshot change
  const uploadScreenshotHandler = (base64) => {
    setState({
      ...state,
      screenshot: base64,
    });
  };

  const handleInputChange = (ev) => {
    setState({ ...state, [ev.target.name]: ev.target.value });
  };

  const removeScreenshotHandler = () => {
    setState({ ...state, screenshot: "" });
  };

  //buttons to be shown in form.
  const submitButton = [
    {
      type: "submit",
      btnProps: {
        text: [
          <img
            src={SaveIcon}
            alt="Save Icon Image"
            className="view-button-icon"
            key={0}
          />,
          "Submit",
        ],
        className: "view-button mr-4",
        variant: "contained",
        method: () => submitHandler(state),
      },
    },
  ];

  return (
    <ModalContainer
      title={"Feedback / Report an issue"}
      open={true}
      onClose={onClose}
      className={"add-container-modal feedback-form"}
    >
      <FormValidator
        data={state}
        rules={rules}
        btns={submitButton}
        btnContainerClass="add-container-action-btns"
      >
        <Grid className="form-container" container>
          <Grid lg={9}>
            {allowEmailInput && (
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                  margin: "normal",
                  className: "add-screen-formcontrol mt-3",
                  style: {
                    width: "95%",
                  },
                }}
                inputProps={{
                  value: state.email,
                  onChange: handleInputChange,
                  label: "Email Id",
                  name: "email",
                  className: "input-add-screen",
                  type: "text",
                  variant: "outlined",
                  required: true,
                }}
              />
            )}
            <CustomInput
              formControlProps={{
                fullWidth: true,
                margin: "normal",
                className: "add-screen-formcontrol",
                style: {
                  width: "95%",
                },
              }}
              inputProps={{
                value: state.message,
                onChange: handleInputChange,
                label: "Enter your feedback / issue",
                name: "message",
                className: "input-add-screen",
                multiline: true,
                rows: messageFeedbackRows,
                variant: "outlined",
                inputProps: { maxLength: 500 },
                required: true,
              }}
            />
            <span className="form-container__text-muted">
              should not be greater than 500 words
            </span>
          </Grid>
          <Grid lg={3} className="form-container__screenshot-picker">
            {state.screenshot && (
              <i
                className="form-container__screenshot-remover cursor-pointer"
                onClick={removeScreenshotHandler}
              >
                <CrossIcon />
              </i>
            )}
            <CustomImagePicker
              name="image"
              value={state.screenshot}
              photoName="Add Screenshot"
              onChange={uploadScreenshotHandler}
              onError={triggerErrorToast}
            />
          </Grid>
          <Divider />
        </Grid>
      </FormValidator>
    </ModalContainer>
  );
};

export default FeedbackForm;
